import dynamic from 'next/dynamic';
import { getIndividualPageData, getPageInfo, } from '@/api/global';

const ProgramPagesLayout = dynamic(() => import('@/components/04_templates/PageLayouts/ProgramPagesLayout'));

export async function getStaticProps(context) {
  const { params } = context;
  let initialProps = {
    statusCode: 200,
  };

  let data = null;

  try {
    data = await getPageInfo(`/programs/${params.program}`);

    let node_data = null;
    if (data && data.page && data.page.entity) {
      node_data = await getIndividualPageData(data.page.jsonapi.individual);
    }

    // Spread translate-path first, node_data last — node_data's status is the
    // real signal for whether the entity loaded.
    initialProps = { ...initialProps, ...(data || {}), ...(node_data || {}) };
    initialProps.statusCode =
      (node_data?.statusCode && node_data.statusCode >= 400) ? node_data.statusCode :
      (data?.statusCode || 200);

    if (!data) {
      return {
        notFound: true,
      };
    }
  }
  catch (e) {
    console.warn('Program page retrieval error:', e);
    initialProps.statusCode = 500;
  }

  return {
    props: {
      ...initialProps,
    },
    revalidate: 10800,
    // notFound: true, // https://github.com/vercel/next.js/discussions/11862,
    // https://stackoverflow.com/questions/67946219/throw-new-errorfailed-to-load-static-props-when-setting-fallback-true-i/67946220#67946220
  };
}

export async function getStaticPaths() {
  const paths = [
    { params: { program: 'women-programs' } },
    { params: { program: 'club-fitting' } },
    { params: { program: 'junior-programs' } },
    { params: { program: 'private-lessons' } },
    { params: { program: 'adult-classes' } },
  ];
  return { paths, fallback: true };
}

function ProgramPage(props) {
  let node, node_data;
  if (props) {
    node = props?.page?.entity || null;
    if (node && props.page_data) {
      node_data = props.page_data;
    }
  }

  return (
    <ProgramPagesLayout node={node_data}/>
  );
}

export default ProgramPage;
